import type { BusinessIssueField } from '@atlassian/jira-business-entity-project/src/services/issue-types-and-fields/types.tsx';
import type { VisualRepresentation } from './types.tsx';

export const getVisualRepresentation = (
	selectedField: BusinessIssueField | undefined,
): VisualRepresentation => {
	if (selectedField === undefined) return 'NONE';
	switch (selectedField?.__typename) {
		case 'JiraNumberField':
			return 'STATISTICS_TABLE';
		default:
			return 'SINGLE_SELECT_CHART';
	}
};

// Showing the chart selector is baked into the SingleSelectChartContainer component,
// so we unfortunately have to repeat the same logic here, but it is needed for the
// ShareButton component to determine if we included the selectedChartType in the URL.
export const isShowingChartTypeSelect = (
	selectedField: BusinessIssueField | undefined,
): boolean => {
	return getVisualRepresentation(selectedField) === 'SINGLE_SELECT_CHART';
};
